import { Grid } from "@mui/material";
import React from "react";
import { Form, useFormState } from "react-final-form";
import Libelle from "../../../_i18n/fr.json";
import CheminDeFer from "../../../components/cheminDeFer/CheminDeFer";
import Layout from "../../../components/Layout";
import LoadingBoundary from "../../../components/LoadingBoundary";

import RenderError from "../../ErrorContainer";
import BienForm from "./AjouterBienForm";
import {
  construireCommunes,
  copyBienFormToModel,
  IBienFormData,
  validateForm,
} from "./helpers";
import { useBienPage } from "./selectors";
import { useNavigate } from "react-router";

function BienPage() {
  const {
    bienData,
    bienFetching,
    bienError,
    nombrePieces,
    nombrePiecesFetching,
    nombrePiecesError,
    typesBien,
    typesBiensFetching,
    typesBiensError,
    typesVoie,
    typeVoieFetching,
    typeVoieError,
    communes,
    chargerCommunes,
    statutDossier,
    dossierDuplique,
    dupliquerDossier,
    duplicationFetching,
    duplicationError,
    initialValues,
    retryFetchingListe,
    ajouterBien,
    modifierBien,
    preRemplirBien,
    supprimerErrorBien,
    errorPostBien,
    errorPutBien,
    modifBienData,
    isLoadingPost,
    isModification,
    canSeeParcoursLocataire,
    dataParcoursLocataire,
  } = useBienPage();

  const navigate = useNavigate();
  const handlePrecedent = () => {
    navigate("/dashboard");
  };

  const onSubmit = (bienForm: IBienFormData) => {
    if (dossierDuplique) {
      dupliquerDossier(bienForm);
    } else if (bienData?.identifiant) {
      modifierBien(bienForm);
      // } else {
      //   ajouterBien(bienModel);
      // }
    } else {
      if (modifBienData) {
        modifierBien(bienForm);
      } else {
        ajouterBien(bienForm);
      }
    }
  };

  return (
    <Layout title={Libelle.pageBien.titre}>
      <CheminDeFer isEtape="monBien" />
      <LoadingBoundary
        loading={nombrePiecesFetching || typeVoieFetching || typesBiensFetching}
        error={typeVoieError || typesBiensError || nombrePiecesError}
        onRetry={retryFetchingListe}
      >
        <Form
          keepDirtyOnReinitialize
          name="bienForm"
          initialValues={initialValues}
          validate={validateForm}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, pristine, submitting, form, values, errors }) => (
            <BienForm
              onSubmit={handleSubmit}
              formValues={values}
              onPrecedent={handlePrecedent}
              onChangeBien={preRemplirBien}
              typesVoie={typesVoie}
              typesBien={typesBien}
              nombrePieces={nombrePieces}
              isFetching={isLoadingPost || duplicationFetching}
              onChangeCommune={chargerCommunes}
              communes={communes && construireCommunes(communes)}
              bienFetching={bienFetching}
              isModification={isModification}
              canSeeParcoursLocataire={canSeeParcoursLocataire}
              dataParcoursLocataire={dataParcoursLocataire}
              statutDossier={statutDossier}
              dossierDuplique={dossierDuplique}
            />
          )}
        </Form>
        <Grid container justifyContent="flex-end" style={{ marginTop: 12 }}>
          {duplicationError && (
            <RenderError
              errors={duplicationError}
              onClose={supprimerErrorBien}
            />
          )}
          {(errorPostBien || errorPutBien) && (
            <RenderError
              errors={errorPostBien || errorPutBien}
              onClose={supprimerErrorBien}
            />
          )}
        </Grid>
      </LoadingBoundary>
    </Layout>
  );
}

export default BienPage;
